import React from 'react';

import { Box } from '@nerdwallet/currency/components/Box';
import { Link } from '@nerdwallet/currency/components/Link';
import { InSitu } from '@nerdwallet/nerdwallet-plus-components';

import { RewardAlertConfigMap } from '@constants/nerdwallet-plus-rewards';
import SegmentImpression from '@components/segment-impression';

import Paths from '@lib/paths';
import { RewardEventPoint } from '@lib/hooks/nerdwallet-plus/use-rewards-points';
import { useIsNerdWalletPlusMember } from '@lib/hooks/nerdwallet-plus';

interface Props extends RewardEventPoint {
  atEdge?: boolean;
  className?: string;
  displayCondition?: boolean;
  onClick?: () => void;
  points: number | string;
  showForNonMembers?: boolean;
}

export const RewardPointsLabel: React.FC<Props> = (props) => {
  const { points, eventType, className, displayCondition, showForNonMembers } =
    props;
  const { isNerdWalletPlusMember } =
    useIsNerdWalletPlusMember(showForNonMembers);

  if (!isNerdWalletPlusMember && !showForNonMembers) return null;

  return displayCondition ? (
    <SegmentImpression
      eventName="Rewards Points Label Viewed"
      eventProps={{
        reward_activity: RewardAlertConfigMap[eventType]?.analyticType,
        points_earned: points,
      }}
    >
      <Link
        href={Paths.NERDWALLET_PLUS}
        unstyled
        aria-label="NerdWallet Plus Reward Label"
      >
        <Box className={className} tabIndex={0}>
          <InSitu {...props} />
        </Box>
      </Link>
    </SegmentImpression>
  ) : null;
};
